import { render, staticRenderFns } from "./ReviewProjectSubmission.vue?vue&type=template&id=27feeff3&scoped=true&"
import script from "./ReviewProjectSubmission.vue?vue&type=script&lang=js&"
export * from "./ReviewProjectSubmission.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProjectSubmission.vue?vue&type=style&index=0&id=27feeff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27feeff3",
  null
  
)

export default component.exports